/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 11:33:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 15:10:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/common.ts
 */
import {
  common,
  defaultStatus,
  generateCollapseOpen,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/common';
enum EnumCollapseId {
  PageSetting = 'PageSetting',
  SeoSetting = 'SeoSetting',
  LegalSetting = 'LegalSetting',
  Content = 'Content',
  MiniProgramShare = 'MiniProgramShare',
}
import { generateDefaultSlug } from 'src/constrains/SlugInput/tool';

const generatePageSetting = () => {
  return { name: 'Legal Page', isNameDuplicate: false, nameIsValid: true };
};

const generateSeoSetting = () => {
  return {
    title: '',
    description: '',
    ...generateDefaultSlug(),
  };
};

const generateLegalSetting = () => {
  return {
    versionRemarks: '',
    useDefaultLegalSetting: true,
    entityName: '',
    entityRegistrationNumber: null,
    consentAttributes: [],
  };
};

const generateContent = () => {
  return { content: '', isEmpty: true };
};

export {
  generateContent,
  generateLegalSetting,
  generatePageSetting,
  EnumCollapseId,
  generateSeoSetting,
  common,
  generateCollapseOpen,
  defaultStatus,
};
